/* eslint-disable */
// Load jQuery from NPM
import 'regenerator-runtime/runtime';

import { openPopup } from './libs/Modals';
import Factory from './libs/Factory';

import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
import "magnific-popup";
// import "jquery-confirm";

import AOS from 'aos';
import 'aos/dist/aos.css';
// import 'animate.css';
// import tooltip from 'bootstrap/js/src/tooltip';

import "print-this";
import toastr from "toastr";
window.toastr = toastr;

const ISZGlobal = window.ISZGlobal || {};

document.addEventListener('DOMContentLoaded', function () {
  setupModules();

  AOS.init({
    duration: 600,
    offset: 300,
  })

  setTimeout(function () {
    document.body.classList.remove('preload');
    setDocHeight();
  }, 10);

  // $(function () {
  //   $('[data-toggle="tooltip"]').tooltip();
  // });

  // banner lightning mask
  const tan25 = Math.tan(25 * Math.PI / 180);
  /** @type {NodeListOf<HTMLElement>} */
  const items = document.querySelectorAll('.hero-slider__item:not(.no-wedge), .hero-img-wrapper');
  items?.forEach((item) => {
    // ev lightning mask
    const body = document.querySelector('body');
    if (body.classList.contains('isuzu-d-max-ev')) {
      item.style.clipPath = `polygon(0 0, 100% 0, 100% 90%, 48% 100%, 52% 90%, 0 100%)`;
    }
  });

  const animatedBgs = document.querySelectorAll('.animated-background');
  animatedBgs?.forEach((item) => {
    item.insertAdjacentHTML(
        'afterbegin',
        `
        <div class="animated-background-wrapper">
            <video src="/wp-content/themes/hello-elementor-child/assets/images/range/ev.mp4" muted loop autoplay playsinline></video>
        </div>`,
    );
  });

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      entry.target.classList.toggle('expanded', entry.isIntersecting);
    });
  }, {
    threshold: 1, // 30% visible
    rootMargin: '-100px 0px -60px 0px',
  });

  document.querySelectorAll('.skewed-bars').forEach(el => {
    observer.observe(el);
  });
});

function setDocHeight() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
}

window.addEventListener('resize', function () {
  setDocHeight();
});

window.addEventListener('orientationchange', function () {
  setDocHeight();
});

function setupModules() {
  const factory = new Factory();
  window.factory = factory;

  const moduleElements = [...document.querySelectorAll('[data-module]')];
  factory.registerModules(moduleElements);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      const rawElements = [m.target, ...m.addedNodes];
      let modifyElements = [];
      rawElements.forEach(function (e) {
        if (e.querySelectorAll) {
          modifyElements = [...modifyElements, ...e.querySelectorAll('[data-module]')];
        }
      });
      const elements = [...rawElements, ...modifyElements].filter(function (e) {
        e.getAttribute && e.getAttribute('data-module') && !e.modules
      });
      factory.registerModules(elements);
    });
  });

  observer.observe(document, {
    subtree: true,
    childList: true,
  });
}

window.ISZGlobal = {
  openPopup(target) {
    openPopup(target);
  },
};
